import { render, staticRenderFns } from "./CommonAddressInfo.vue?vue&type=template&id=282cda14&"
import script from "./CommonAddressInfo.vue?vue&type=script&lang=js&"
export * from "./CommonAddressInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports